/**
 * Trip Recording Types for FlowRide
 * Defines types for trip recording and replay functionality
 */

import { CompassData, RawGpsData } from "./Navigation";

/**
 * Metadata about a recorded trip
 */
export interface TripMetadata {

    /** Trip ID from database */
    "id"?: number;

    /** City name at start point */
    "startCity": string;

    /** City name at end point */
    "endCity": string;

    /** Date of trip start */
    "startDate": string;

    /** Start timestamp in milliseconds */
    "startTimestamp": number;

    /** End timestamp in milliseconds */
    "endTimestamp": number;

    /** Trip duration in milliseconds */
    "duration": number;

    /** Timestamp when recorded */
    "createdAt"?: Date;

    /** Timestamp when last updated */
    "updatedAt"?: Date;
}

/**
 * Complete recorded trip data including GPS and compass data
 */
export interface RecordedTripData {

    /** Trip metadata */
    "metadata": TripMetadata;

    /** Array of raw GPS data points */
    "gpsData": RawGpsData[];

    /** Array of compass data points */
    "compassData": CompassData[];
}

/**
 * Structure for uploading trip data to backend
 */
export interface TripRecordingUpload {

    /** Array of raw GPS data points */
    "gpsData": RawGpsData[];

    /** Array of compass data points */
    "compassData": CompassData[];
}

/**
 * Recording state
 */
export enum RecordingState {

    /** Not recording */
    "STOPPED" = "stopped",

    /** Recording in progress */
    "RECORDING" = "recording",

    /** Recording paused */
    "PAUSED" = "paused",
}

/**
 * Replay state
 */
export enum ReplayState {

    /** Not replaying */
    "STOPPED" = "stopped",

    /** Replaying in progress */
    "PLAYING" = "playing",

    /** Replay paused */
    "PAUSED" = "paused",
}

